import {
  createHandoffId,
  storeIntegrationHandoffPayload,
} from "../lib/journeyHandoff";
import {
  isAgentHandoffAction,
  resolveJourneyPath,
  type SamiJourneyPayload,
  type SamiJourneyStep,
} from "./conciergeJourney";

export function primaryProductUuid(
  journey: SamiJourneyPayload,
): string | undefined {
  return journey.recommendedProducts[0]?.uuid;
}

export function stepTargetPath(
  step: SamiJourneyStep,
  productUuid?: string,
): string {
  if (isAgentHandoffAction(step.action)) {
    return step.action.path;
  }
  return resolveJourneyPath(step.action.path, productUuid);
}

/** Build navigation target for a journey step (path + search for handoffs). */
export function buildStepNavigationTarget(
  step: SamiJourneyStep,
  journey: SamiJourneyPayload,
): string {
  const productUuid = primaryProductUuid(journey);
  const action = step.action;

  if (isAgentHandoffAction(action)) {
    const handoffId = createHandoffId();
    storeIntegrationHandoffPayload(handoffId, {
      initialPrompt: action.initialPrompt,
      productUuid: action.productUuid ?? productUuid,
      tab: action.tab ?? "integrate",
    });
    const params = new URLSearchParams();
    params.set("tab", action.tab ?? "integrate");
    const uuid = action.productUuid ?? productUuid;
    if (uuid) params.set("productUuid", uuid);
    params.set("handoffId", handoffId);
    return `${action.path}?${params.toString()}`;
  }

  return resolveJourneyPath(action.path, productUuid);
}
